import CachePersistor from './CachePersistor';
export default (function (options) {
    var persistor = new CachePersistor(options);
    return persistor.restore();
});
